import { Stack } from "@mui/material";
import { useTheme } from "design-system/themeContext";
import React from "react";
import { useTranslation } from "react-i18next";

import { getIsDefaultTheme } from "../design-system/themeSelection";
import { LeaftechLogo } from "./CompanyLogo";
import { DividerHorizontal } from "./Divider";

export const Footer = ({ className }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const isDefaultTheme = getIsDefaultTheme(theme.name);

  return (
    <footer className={`mt-3 h-8 text-neutral-600 font-ds-body-regular-xs ${className}`}>
      <DividerHorizontal softest />
      <Stack className="mt-4 justify-between">
        <span className="text-lds-foreground-secondary">{t(`SharedLayout.footer.copyright`)}</span>
        {!isDefaultTheme && <LeaftechLogo imgProps={{ className: "w-20" }} />}
        <Stack className="text-lds-foreground-secondary" spacing={8}>
          <span className="text-lds-link-primary">{t(`SharedLayout.footer.imprint`)}</span>
          <span className="text-lds-link-primary">{t(`SharedLayout.footer.privacyPolicy`)}</span>
        </Stack>
      </Stack>
    </footer>
  );
};
